import React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'
import { truncateText } from '@utils/truncate-text'

interface TextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: string
  limitCharacters?: number
}

interface TextTitleProps extends TextProps {
  textType: 'title'
  fontWeight?: 'bold' | 'regular'
  size?: 'md' | 'lg'
}

interface TextSubtitleProps extends TextProps {
  textType: 'subtitle'
  fontWeight?: 'bold'
  size?: 'md'
}

interface TextRegularProps extends TextProps {
  textType: 'description'
  fontWeight?: 'regular' | 'thin'
  size?: 'sm' | 'md'
}

export const Text = ({
  textType = 'subtitle',
  fontWeight = 'bold',
  size = 'md',
  children,
  limitCharacters,
  className,
  ...rest
}: TextTitleProps | TextSubtitleProps | TextRegularProps): JSX.Element => (
  <p
    className={classnames(
      className,
      styles.text,
      styles[textType],
      styles[fontWeight],
      styles[size]
    )}
    {...rest}
  >
    {limitCharacters ? truncateText(children, limitCharacters) : children}
  </p>
)
